// src/constants.jsx
export const stateNames = {
    "AN": "Andaman and Nicobar Islands",
    "AP": "Andhra Pradesh",
    "AR": "Arunachal Pradesh",
    "AS": "Assam",
    "BR": "Bihar",
    "CH": "Chandigarh",
    "CT": "Chhattisgarh",
    "DN": "Dadra and Nagar Haveli and Daman and Diu",
    "DL": "Delhi",
    "GA": "Goa",
    "GJ": "Gujarat",
    "HR": "Haryana",
    "HP": "Himachal Pradesh",
    "JK": "Jammu and Kashmir",
    "JH": "Jharkhand",
    "KA": "Karnataka",
    "KL": "Kerala",
    "LA": "Ladakh",
    "LD": "Lakshadweep",
    "MP": "Madhya Pradesh",
    "MH": "Maharashtra",
    "MN": "Manipur",
    "ML": "Meghalaya",
    "MZ": "Mizoram",
    "NL": "Nagaland",
    "OR": "Odisha",
    "PY": "Puducherry",
    "PB": "Punjab",
    "RJ": "Rajasthan",
    "SK": "Sikkim",
    "TN": "Tamil Nadu",
    "TG": "Telangana",
    "TR": "Tripura",
    "UP": "Uttar Pradesh",
    "UT": "Uttarakhand",
    "WB": "West Bengal"
};

export const drcByState = {
    "AN": "", // Andaman and Nicobar Islands
    "AP": "GNT/5074/ADDL.DA/FW/2021/00561", // Andhra Pradesh
    "AR": "", // Arunachal Pradesh
    "AS": "FERT-WS-F/2026/00061", // Assam
    "BR": "", // Bihar
    "CH": "", // Chandigarh
    "CT": "", // Chhattisgarh
    "DN": "", // Dadra and Nagar Haveli and Daman and Diu
    "DL": "", // Delhi
    "GA": "", // Goa
    "GJ": "75/18", // Gujarat
    "HR": "MoA No.: 2025720", // Haryana
    "HP": "", // Himachal Pradesh
    "JK": "JKSP00000103", // Jammu and Kashmir
    "JH": "", // Jharkhand
    "KA": "JDA/F&PP/KAR/FE1920122751/2022-2023", // Karnataka
    "KL": "", // Kerala
    "LA": "", // Ladakh
    "LD": "", // Lakshadweep
    "MP": "", // Madhya Pradesh
    "MH": "LCBWD0620250046", // Maharashtra
    "MN": "", // Manipur
    "ML": "", // Meghalaya
    "MZ": "", // Mizoram
    "NL": "", // Nagaland
    "OR": "", // Odisha
    "PY": "", // Puducherry
    "PB": "LOA No. - PB/AGRI/FERT/2023/5", // Punjab
    "RJ": "", // Rajasthan
    "SK": "", // Sikkim
    "TN": "", // Tamil Nadu
    "TG": "FERT-W-260367", // Telangana
    "TR": "", // Tripura
    "UP": "JDA FERTILIZER/419/LKO/1", // Uttar Pradesh
    "UT": "UK-AGRI/60266/62860", // Uttarakhand
    "WB": "F44846" // West Bengal
};

const biostimulantProductsBase = [
    {
        id: 1,
        brandName: "Humira",
        titleName:"Humira",
        gazette: "S.0. 876 (E) Dated 16-02-2026",
        title: " Humic Acid 5% (Powder)",
        composition: {
            "Humic acid (Source : Leonardite) percent by weight, minimum": "5.0",
            "Potassium as K2O percent by weight, minimum": "5.5",
            "Ammonium lauryl sulfate (anionic surfactant) percent by weight, maximum": "9.5",
            "Sorbitols/carboxylates/sulphates percent by weight, maximum": "80",
            "Total (Percent)": "100",
        },
        crops: "Chilli pepper",
        doses: "Three foliar applications at 250 gram/ha",
        table: null,

    },
    {
        id: 2,
        brandName: "HumiShine",
        titleName:"HumiShine",
        gazette: "S.0. 876 (E) Dated 16-02-2026",
        title: "Potassium Humate 49% (Powder)",
        composition: {
            "Potassium humate (Source : Leonardite) percent by weight, minimum": "49",
            "Silwet power (adjuvant) percent by weight, maximum": "0.5",
            "Carboxymethyl cellulose percent by weight, maximum": "1.0",
            "Maltodextrin powder percent by weight": "QS",
            "Total (Percent)": "100",
        },
        crops: "Paddy, Tomato",
        doses: "As given in table below",
        table: [
            { "srNo": 1, "crop": "Paddy", "dose": "One soil application at 1 kg/ha" },
            { "srNo": 2, "crop": "Tomato", "dose": "One soil application at 1 kg/ha" },
        ]

    },
    {
        id: 3,
        brandName: "HumiGem",
        titleName:"HumiGem",
        gazette: "S.0. 876 (E) Dated 16-02-2026",
        title: "Humates and Fulvates 22% (Liquid)",
        composition: {
            "Humates (Source : Leonardite) percent weight by volume, minimum": "19",
            "Fulvates percent weight by volume, minimum": "3",
            "Water percent weight by volume, maximum": "78",
            "Total (Percent)": "100"
        },
        crops: "Groundnut",
        doses: "Two soil applications at 1.25 L/ha",
        table: null
    },
    {
        id: 4,
        brandName: "HumiRise",
        titleName:"HumiRise",
        gazette: "S.0. 876 (E) Dated 16-02-2026",
        title: "Humates 12.5% (Liquid)",
        composition: {
            "Humic Acid (Source : American Leonardite) percent by weight minimum" : "10.0",
            "Fulvic Acid (Source : American Leonardite) percent by weight minimum": "2.5",
            "Tetrapotassium pyrophosphate percent by weight, minimum": "0.9",
            "Potassium hydroxide 50 % solution percent by weight, minimum": "10.0",
            "Alcoxylated fatty acid ester on vegetable base percent by weight, minimum": "0.7",
            "Water percent by weight": "Q.S.",
            "Total (percent)": "100",
        },
        crops: "Green gram",
        doses: "Two soil applications at 5 l/ha",
        table: null

    },
    {
        id: 5,
        brandName: "H-60",
        titleName:"H-60",
        gazette: "S.0. 876 (E) Dated 16-02-2026",
        title: "Humic Acid 51% (Granular)",
        composition: {
            "Humic Acid (Source : American Leonardite) percent by weight, minimum": "51",
            "Fulvic Acid percent by weight minimum": "10",
            "Potassium as K2O percent by weight, Minimum": "16",
            "Tetrapotassium pyrophosphate percent by weight, minimum": "4.50",
            "Lignosulphonic acid percent by weight, minimum": "14.22",
            "Alcoxylated fatty acid ester on vegetable base percent by weight, minimum": "0.36",
            "Water percent by weight, maximum": "3.92",
            "Total (Percent)": "100"
        },
        crops: "Green gram",
        doses: "Two soil applications at 1.5 Kg/ha",
        table: null

    },
    {
        id: 6,
        brandName: "SeaGem Liquid",
        titleName:"SeaGem Liquid / Biogreen / RTU Grows All",
        gazette: "S.0. 876 (E) Dated 16-02-2026",
        title: "Ascophyllum Nodosum 15% (Liquid)",
        composition: {
            "Seaweed (Ascophyllum nodosum) extract percent by weight, minimum": "15",
            "Potassium Sorbate percent by weight, minimum": "0.28",
            "Citric acid percent by weight, minimum": "1.91",
            "Water, percent by weight, Maximum": "82.81",
            "Total (percent)": "100"
        },
        crops: "Green gram",
        doses: "Two foliar applications at 1500 ml/ha",
        table: null

    },
    {
        id: 7,
        brandName: "G5 Granules",
        titleName:"G5 Granules",
        gazette: "S.0. 3741 (E)  Dated 13-08-2025",
        title: "Mixture of Seaweed extract, Protein Hydrolysate and Humic acid (Granule)",
        composition: {
            "Seaweed extract (Ascophyllum nodosum) percent by weight, maximum": "0.5",
            "Protein hydrolysate derived from defatted soy flour by enzymatic (papain) hydrolysis percent by weight, minimum": "0.5",
            "Humic acid (source: Leonardite) percent by weight, minimum": "0.02",
            "Polysorbate 80 percent by weight, minimum ": "0.05",
            "Bentonite granules percent by weight": "QS",
            "Total (percent)": "100"

        },
        crops: "Onion, Paddy and Potato",
        doses: "Two soil application at 10 Kg/ha.",
        table: null

    },
    {
        id: 8,
        brandName: "KappaGrow",
        titleName:"KappaGrow",
        gazette: "S.0. 3922 (E) Dated 12-09-2024",
        title: "Kappaphycus alvarezii 24% (Liquid)",
        composition: {
            "Total Carbohydrate percent by weight minimum": "7.5",
            "D-Galactose-4-O-Sulphate percent by weight minimum": "6.0",
            "pH (minimum) (1:2 aqueous solution)": "3.0 - 5.0",
        },
        crops: "Cucumber",
        doses: "One foliar application at 2 ml/l",
        table: null

    },
    {
        id: 9,
        brandName: "G5 Foliar",
        titleName:"G5 Foliar",
        gazette: "S.0. 876 (E) Dated 16-02-2026",
        title: "Seaweed (Sargassum tenerrimum) 10% (Liquid)",
        composition: {
            "Seaweed (Sargassum tenerrimum) extract percent by weight minimum": "10",
            "PEG400 as adjuvant percent by weight, maximum": "0.1",
            "Water percent by weight, maximum": "89.9",
            "Water (Percent)": "100",
        },
        crops: "Paddy, Tomato",
        doses: "As given in table below",
        table: [
            { "srNo": 1, "crop": "Paddy", "dose": "One foliar application at 625 ml/l" },
            { "srNo": 2, "crop": "Tomato", "dose": "Two foliar application at 625 ml/l" },
        ]
    },
    {
        id: 10,
        brandName: "VasiMax",
        titleName:"VasiMax",
        gazette: "S.0. 3922 (E) Dated 12-09-2024",
        title: "Adhatoda vassica (Powder)",
        composition: {
            "Vasicine minimum": "5 ppm",
            "Seaweed extract percent by weight minimum": "5",
            "pH (1% aqueous solution)": "7.0 - 8.0",
        },
        crops: "Potato",
        doses: "Single soil application at 10 Kg/ha",
        table: null
    },
    {
        id: 11,
        brandName: "Vira HD Powder",
        titleName:"Vira HD Powder",
        gazette: "S.0. 3922 (E) Dated 12-09-2024",
        title: "Mixture of Humic Acid, Amino Acid, Vitamins and Bio-chemicals (Powder)",
        composition: {
            "Humic Acid percent by weight minimum": "30",
            "Amino Acid (Glycine) percent by weight minimum": "7",
            "Myoinositol percent by weight minimum": "2",
            "Vitamin C percent by weight minimum": "12.0",
            "Vitamin E percent by weight minimum": "0.2",
            "pH (1% aqueous solution)": "5.0 - 6.5",
            "Total Organic Carbon percent by weight minimum": "25",
        },
        crops: "Okra",
        doses: "Two soil applications at 250 g/ha",
        table: null
    },
    {
        id: 12,
        brandName: "Nitrosil G 20 Granules",
        titleName:"Nitrosil G 20 Granules",
        gazette: "S.0. 2346 (E) Dated 26-05-2025",
        title: "Protein hydrolysate 1.5% (Plant Source) (Granules)",
        composition: {
            "Protein hydrolysate derived from defatted Soybean seed flour by enzymatic (Papain) hydrolysis percent by weight, minimum": "1.5",
            "Bentonite percent by weight, maximum": "98.5",
            "Total (per cent.)": "100"
        },
        crops: "Tomato",
        doses: "Two soil applications at 40 Kg/ha",
        table: null
    },
    {
        id: 13,
        brandName: "Swa Bumper Gold",
        titleName:"Swa Bumper Gold",
        gazette: "S.0. 3741 (E)  Dated 13-08-2025",
        title: "Homobrassinolide-0.04% (Liquid)",
        composition: {
            "Homobrassinolide (Source: Synthetic) percent by weight, minimum": "0.04",
            "Polysorbate 20 as adjuvant percent by weight, minimum": "2.00",
            "4- Nonylphenol ethoxylated percent by weight, minimum": "2.00",
            "Isopropyl alcohol percent by weight": "Q.S",
            "Total (percent)": "100"
        },
        crops: "Tea, Grape, Groundnut, Soybean, Paddy, Cotton and Tomato",
        doses: "As given in the table below",
        table: [
            { "srNo": 1, "crop": "Tea", "dose": "Three foliar applications at 250 ml/ha" },
            { "srNo": 2, "crop": "Grape", "dose": "Two foliar applications at 1000 ml/ha" },
            { "srNo": 3, "crop": "Groundnut", "dose": "Two foliar applications at 250 ml/ha" },
            { "srNo": 4, "crop": "Soybean", "dose": "Two foliar applications at 250 ml/ha" },
            { "srNo": 5, "crop": "Paddy", "dose": "Two foliar applications at 250 ml/ha" },
            { "srNo": 6, "crop": "Cotton", "dose": "Two foliar applications at 250 ml/ha" },
            { "srNo": 7, "crop": "Tomato", "dose": "Two foliar applications at 250 ml/ha" }
        ]
    },
    {
        id: 14,
        brandName: "Swa Bumper",
        titleName:"Swa Bumper",
        gazette: "S.0. 3741 (E)  Dated 13-08-2025",
        title: "Homobrassinolide - 0.03% (Liquid)",
        composition: {
            "Homobrassinolide (Source: Synthetic) percent by weight, minimum": "0.03",
            "Lauryl alcohol ethoxylate percent by weight, minimum": "2.00",
            "4- Nonylphenol ethoxylated percent by weight, minimum": "2.00",
            "Methyl alcohol": "Q.S",
            "Total (percent)": "100"
        },
        crops: "Grape",
        doses: "Two Foliar applications at 1000 ml/ha",
        table: null

    },
    {
        id: 15,
        brandName: "BromoPlus",
        titleName:"BromoPlus",
        gazette: "S.0. 2346 (E)  Dated 26-05-2025",
        title: "2- Bromo - (1 H) - Indole - 3 Carboxaldehyde 1 ppm (Liquid)",
        composition: {
            "2- Bromo - (1 H) - Indole - 3 Carboxaldehyde percent by weight, minimum": "0.0001",
            "Water percent by weight": "Q.S.",
            "Total (percent)": "100"
        },
        crops: "Tomato",
        doses: "Seed treatment at 1 ppm formulation",
        table: null

    },
    {
        id: 16,
        brandName: "MaxGrow",
        titleName:"MaxGrow",
        gazette: "S.0. 876 (E) Dated 16-02-2026",
        title: "Humic and Fulvic acid 14 % (Liquid)",
        composition: {
            "Fulvic Acid percent by weight minimum": "10.0",
            "Potassium humate percent by weight, Minimum": "6.66",
            "Polysorbate 80 percent by weight, minimum": "0.10",
            "Water percent by weight": "Q.S",
            "Total (Percent)": "100",
        },
        crops: "Brinjal",
        doses: "First applications as root dipping and two subsequent foliar applications at 1250 ml /ha",
        table: null

    },
    {
        id: 17,
        brandName: "GlyGem",
        titleName:"GlyGem",
        gazette: "S.0. 3741 (E) Dated 13-08-2025",
        title: "Glycine 5 % (Powder)",
        composition: {
            "Glycine percent by weight, minimum": "5",
            "Dextrin percent by weight, maximum": "95",
            "Total (percent)": "100"
        },
        crops: "Brinjal",
        doses: "Three Foliar applications at 1000 g/ha",
        table: null

    },
    {
        id: 18,
        brandName: "Proliva",
        titleName:"Proliva",
        gazette: "S.0. 3741 (E) Dated 13-08-2025",
        title: "Proline 1 % (Liquid)",
        composition: {
            "Proline percent by weight, minimum": "1",
            "Water percent by weight": "99",
            "Total (percent)": "100"
        },
        crops: "Capsicum",
        doses: "Three Foliar applications at 500 ml/ha",
        table: null

    },
    {
        id: 19,
        brandName: "Toco - P",
        titleName:"Toco - P",
        gazette: "S.0. 3741 (E) Dated 13-08-2025",
        title: "Vitamin (Alpha Tocopherol) 1% (Liquid)",
        composition: {
            "Alpha tocopherol (Vitamin - E) (Source : Sunflower Oil) percent by weight, minimum": "1",
            "Tween 80 percent by weight, minimum": "6",
            "Cottonseed oil percent by weight, minimum": "93",
            "Total (percent)": "100"
        },
        crops: "Chilli",
        doses: "Three Foliar applications at 1000 ml/ha",
        table: null

    },
    {
        id: 20,
        brandName: "Nico Grow",
        titleName:"Nico Grow",
        gazette: "S.0. 3741 (E) Dated 13-08-2025",
        title: "Vitamin B 3 (Nicotinamide) 3.25 % (Liquid)",
        composition: {
            "Vitamin B 3 - Niacinamide (Nicotinamide) (synthetic) percent by weight, minimum": "3.25",
            "Emulsifier (Nonyl Phenol Ethoxylate) percent by weight, minimum": "16.75",
            "Solvent (Dimethyl sulfoxide) percent by weight, minimum": "80",
            "Total (percent)": "100"
        },
        crops: "Tomato",
        doses: "Two Foliar applications at 1.25 ml/ha",
        table: null

    },
    {
        id: 21,
        brandName: "Cyto - L",
        titleName: "Cyto - L",
        gazette: "S.0. 3741 (E) Dated 13-08-2025",
        title: "Cytokinin (Zea mays Kernal) 0.2 % (Liquid)",
        composition: {
            "Cytokinin (Source : Zea mays Kernal) percent weight by volume , minimum ": "0.02",
            "Potassium sorbate percent weight by volume, minimum": "0.001",
            "Demineralized aqua percent by weight": "Q.S",
            "Total (percent)": "100"
        },
        crops: "Capsicum",
        doses: "Three Foliar applications at 750 ml/ha",
        table: null

    },
    {
        id: 22,
        brandName: "Glumac",
        titleName:"Glumac",
        gazette: "S.0. 3741 (E) Dated 13-08-2025",
        title: "Glutamic acid 5 % Powder",
        composition: {
            "Glutamic acid percent by weight, minimum": "5",
            "Dextrin percent by weight, maximum": "95",
            "Total (percent)": "100"
        },
        crops: "Brinjal",
        doses: "Three Foliar applications at 1000 g/ha",
        table: null

    },
    {
        id: 23,
        brandName: "SeaGem Powder",
        titleName:"SeaGem Powder",
        gazette: "S.0. 3741 (E) Dated 13-08-2025",
        title: "Ascophyllum Nodosum 90 % (Flakes)",
        composition: {
            "Seaweed extract (Ascophyllum nodosum) percent by weight, minimum": "90",
            "Moisture percent by weight, maximum": "10",
            "Total (percent)": "100"
        },
        crops: "Tomato",
        doses: "Three Foliar applications at 750 g/ha",
        table: null
    },
    {
        id: 24,
        brandName: "SeaGem Granules",
        titleName:"SeaGem Granules",
        gazette: "S.0. 876 (E) Dated 16-02-2026",
        title: "Seaweed (Ascophyllum nodosum) extract 2 % (Granule)",
        composition: {
            "Seaweed extract (Ascophyllum nodosum) fermented percent by weight, minimum": "2.0",
            "Bentonite percent by weight, maximum": "98",
            "Total (percent)": "100"
        },
        crops: "Rice, Wheat and Sugarcane",
        doses: "As given in table below",
        table: [
            { "srNo": 1, "crop": "Rice", "dose": "Two Soil applications  at 15 g/ha" },
            { "srNo": 2, "crop": "Wheat", "dose": "Two Soil applications at 25 g/ha" },
            { "srNo": 3, "crop": "Sugarcane", "dose": "Two Soil applications at 60 g/ha" },
        ]
    },
    {
        id: 25,
        brandName: "Potasil Granules",
        titleName:"Potasil Granules",
        gazette: "S.0. 876 (E) Dated 16-02-2026",
        title: "Protein hydrolysate 1.8 % (Plant Source) (Granule)",
        composition: {
            "Protein hydrolysate derived from soybean and maize seed through enzymatic (exo- and endo- proteases) and mild acid (hydrochloric acid) hydrolysis percent by weight, minimum": "1.8",
            "Bentonite percent by weight, maximum": "Q.S.",
            "Total (percent)": "100"
        },
        crops: "Cumin, Potato, Wheat, Chilli, Groundnut and Cucumber",
        doses: "As given in table below",
        table: [
            { "srNo": 1, "crop": "Cumin", "dose": "One Soil applications at 10 kg/ha" },
            { "srNo": 2, "crop": "Potato", "dose": "One Soil applications at 10 kg/ha" },
            { "srNo": 3, "crop": "Wheat", "dose": "One Soil applications at 10 kg/ha" },
            { "srNo": 4, "crop": "Chilli", "dose": "One Soil applications at 20 kg/ha" },
            { "srNo": 5, "crop": "Groundnut", "dose": "Three Soil applications at 10 kg/ha" },
            { "srNo": 6, "crop": "Cucumber", "dose": "Two Soil applications at 12.5 kg/ha" },
        ]
    },
    {
        id: 26,
        brandName: "Humigel",
        titleName:"Humigel",
        gazette: "S.0. 876 (E) Dated 16-02-2026",
        title: "Humates 12.5% (Liquid)",
        composition: {
            "Humic Acid (Source : American Leonardite) percent by weight minimum": "10.0",
            "Fulvic Acid (Source : American Leonardite) percent by weight minimum": "2.5",
            "Tetrapotassium pyrophosphate percent by weight, minimum": "0.9",
            "Potassium hydroxide 50 % solution percent by weight, minimum": "10.0",
            "Alcoxylated fatty acid ester on vegetable base percent by weight, minimum": "0.7",
            "Water percent by weight": "Q.S.",
            "Total (percent)": "100",
        },
        crops: "Green gram",
        doses: "Two soil applications at 5 Liter/ha",
        table: null,
    },
    {
        id: 27,
        brandName: "Humacid",
        titleName:"Humacid / Rootstar",
        gazette: "S.0. 2346 (E) Dated 26-05-2025",
        title: "Humic Acid 6 % (Liquid)",
        composition: {
            "Humic Acid (as Potassium humate obtained from Leonardite mineral source) percent by weight minimum": "6.0",
            "Water percent by weight": "Q.S.",
            "Total (percent)": "100",
        },
        crops: "Tomato",
        doses: "Three foliar applications at 1.25 Liter/ha",
        table: null,

    },
    {
        id: 28,
        brandName: "Germiseed",
        titleName:"Germiseed",
        gazette: "S.0. 2346 (E) Dated 26-05-2025",
        title: "Humic Acid 6 % (Liquid)",
        composition: {
            "Humic Acid (as Potassium humate obtained from Leonardite mineral source) percent by weight minimum": "6.0",
            "Water percent by weight": "Q.S.",
            "Total (percent)": "100",
        },
        crops: "Tomato",
        doses: "Three foliar applications at 1.25 Liter/ha",
        table: null,
    },
    {
        id: 29,
        brandName: "Amirich",
        titleName:"Amirich",
        gazette: "S.0. 2346 (E) Dated 26-05-2025",
        title: "Protein hydrolysate 16.9 % (Plant Source) (Liquid)",
        composition: {
            "Protein hydrolysate derived from seeds of Glycine max and Zea mays in ratio of 5.5 : 4.5 through enzymatic (food grade Alcalase) hydrolysis percent by weight, minimum": "16.90",
            "Potassium Sorbate and Vegetable base fatty acid percent by weight, minimum": "21.00",
            "Water percent by weight": "Q.S.",
            "Total (percent)": "100",
        },
        crops: "Green gram",
        doses: "Two foliar applications at 1.5 L/ ha",
        table: null,
    },
    {
        id: 30,
        brandName: "Humacid Granules",
        titleName:"Humacid Granules",
        gazette: "S.0. 876 (E) Dated 16-02-2026",
        title: "Humic Acid 1.5 % Granules",
        composition: {
            "Humic Acid (as Potassium humate obtained from Leonardite mineral source) percent by weight, minimum": "1.5",
            "Bentonite percent by weight, maximum as carrier": "98.5",
            "Total (percent)": "100",
        },
        crops: "Chilli",
        doses: "Two soil applications at 30 Kg/ ha",
        table: null,
    },
    {
        id:31,
        brandName: "Maxlinea",
        titleName:"Maxlinea",
        gazette: "S.0. 3741 (E) Dated 13-08-2025",
        title: "Cytokinin (Zea mays kernel) 0.2% (Liquid)",
        composition: {
            "Cytokinin (Source : Zea mays Kernal) percent weight by volume, minimum": "0.02",
            "Potassium sorbate percent weight by volume, minimum": "0.001",
            "Demineralized aqua percent by weight": "Q.S",
            "Total (percent)": "100",
        },
        crops: "Capsicum",
        doses: "Three Foliar applications at 750 ml/ha",
        table: null,
    },
    {
        id:32,
        brandName: "Phytomax",
        titleName:"Phytomax",
        gazette: "S.0. 3741 (E) Dated 13-08-2025",
        title: "Proline 1 % (Liquid)",
        composition: {
            "Proline percent by weight, minimum": "1",
            "Water percent by weight": "99",
            "Total (percent)": "100",
        },
        crops: "Capsicum",
        doses: "Three Foliar applications at 500 ml/ha",
        table: null,
    },

];

export const biostimulantProducts = biostimulantProductsBase.map((product) =>
    Object.assign({}, product, { drc: drcByState })
);